import { render, staticRenderFns } from "./NewCustomContentVersionModal.vue?vue&type=template&id=e4e8b07e&scoped=true"
import script from "./NewCustomContentVersionModal.vue?vue&type=script&lang=js"
export * from "./NewCustomContentVersionModal.vue?vue&type=script&lang=js"
import style0 from "./NewCustomContentVersionModal.vue?vue&type=style&index=0&id=e4e8b07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e8b07e",
  null
  
)

export default component.exports